import React from 'react';

import { clsx } from '../../utils/utils';
import * as styles from './Arc.module.scss';

export interface ArcProps {
  borderSide?: 'left' | 'right';
  showOnlyInDesktop?: boolean;
  className?: string;
}

const Arc = ({ borderSide, showOnlyInDesktop, className }: ArcProps): React.ReactElement => {
  return (
    <div
      className={clsx(
        styles.container,
        borderSide === 'left' && styles.leftBorder,
        showOnlyInDesktop && styles.showOnlyInDesktop,
        className,
      )}
    >
      <div className={styles.border}></div>
    </div>
  );
};

export default Arc;
